import React, {useState} from 'react';
import {Typography, Button, Paper, Stack, Alert, AlertTitle, TextField, FormControl, InputLabel, Select, MenuItem, IconButton, InputAdornment, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions} from '@mui/material';
import {BackupRounded,Add,SendRounded, DeleteRounded, DeleteForever, RestoreFromTrashRounded} from '@mui/icons-material';
import { backup, cleanOldData, writeDataAdmin, changePassword, cleanImgAndBackup } from '../utils/datautils';
import { Section } from '../utils/other';
import { useDispatch, useSelector } from 'react-redux';
import { data, dataAdmin, residueImg, setData, setDataAdmin } from '../../storeredux';
import bcryptjs from 'bcryptjs';

export default function DeveloperContainer(props) {
  const {setResponse,setError} = props
  const listAdmin = useSelector(dataAdmin)
  const dataAll = useSelector(data)
  const oldImgs = useSelector(residueImg)
  const dispatch = useDispatch()
  const adminNull = {
    'name':'',
    'type':'admin',
    'password':'',
    '_password':''
  }
  const passwordNull = {
    'name':'',
    'password':'',
    'passwordNew':'',
  }
  const [admin,setAdmin] = useState(adminNull)
  const [password,setPassword] = useState(passwordNull)
  const [removeScale,setRemoveScale] = useState(50)
  const [open,setOpen] = useState(false)

  return(
    <Stack spacing={4} sx={{justifyContent:'center',alignItems:"center",margin:'10px'}}>
      <Typography variant='h2' sx={{fontFamily:'monospace',fontWeight:700,color:'#719de3'}}>Developer Page</Typography>
      <Alert severity='warning' sx={{maxWidth:'90vw'}}>
        <AlertTitle>Attention</AlertTitle>
        This Page Only For Developer and Head Administrator, besides them not allowed
      </Alert>
      <Section name="Change Password" align="left"/>
      <Stack width="100%" sx={{maxWidth:'500px'}}>
        <Paper width="100%" sx={{padding:'10px',background:'#e3e3e3',borderRadius:'10px'}}>
          <Stack width="100%" spacing={2}>
            <TextField
              required
              type='text'
              label='Name'
              variant='standard'
              value={password.name}
              onChange={(val) => {setPassword({...password,'name':val.currentTarget.value})}}
            />
            <TextField
              required
              type='text'
              label='Password'
              variant='standard'
              value={password.password}
              onChange={(val) => {setPassword({...password,'password':val.currentTarget.value})}}
            />
            <TextField
              required
              type='text'
              label='NewPassword'
              variant='standard'
              value={password.passwordNew}
              onChange={(val) => {setPassword({...password,'passwordNew':val.currentTarget.value})}}
            />
            <Button variant='contained' startIcon={<SendRounded/>} onClick={() => {
              changePassword(listAdmin,password.name,password.password,password.passwordNew).then(dtmain => {
                dispatch(setDataAdmin(dtmain))
              }).catch(err => {setError(err.message)})
            }}>Change</Button>
          </Stack>
        </Paper>
      </Stack>
      <Section name="Add Admin" align="right"/>
      <Stack width="100%" sx={{maxWidth:'500px'}}>
        <Paper width="100%" sx={{padding:'10px',background:'#e3e3e3',borderRadius:'10px'}}>
          <Stack width="100%" spacing={2}>
            <TextField
              required
              type='text'
              label='Name'
              variant='standard'
              value={admin.name}
              onChange={(val) => {setAdmin({...admin,'name':val.currentTarget.value})}}
            />
            <TextField
              required
              type='text'
              label='Password'
              variant='standard'
              value={admin._password}
              onChange={(val) => {setAdmin({...admin,'_password':val.currentTarget.value})}}
            />
            <Button variant='contained' startIcon={<Add/>} onClick={() => {
                var adminwd = {...admin,'password':bcryptjs.hashSync(admin._password,12)}
                dispatch(setDataAdmin([adminwd,...listAdmin]));setAdmin(adminNull)}}>Add to Queue</Button>
            <Stack width="100%" spacing={2} maxHeight={'400px'} sx={{overflow:'auto'}}>
              {
                listAdmin.filter(vs => vs.hasOwnProperty('_password')).map((dt,i) => (
                  <Alert key={i} severity='success' action={
                    <Stack direction={'row'} spacing={1}>
                      <Button variant='contained' color='success' size="small" 
                        sx={{fontWeight:700}} onClick={() => {setAdmin(dt);dispatch(setDataAdmin(listAdmin.filter(ty => ty !== dt)))}}>
                        UPDATE
                      </Button>
                      <IconButton color='error' onClick={() => {dispatch(setDataAdmin(listAdmin.filter(ty => ty !== dt)))}}>
                        <DeleteRounded/>
                      </IconButton>
                    </Stack>
                  }>
                    <strong>name:</strong> {dt.name}<br/>
                    <strong>password:</strong> {dt._password}
                  </Alert>
                ))
              }
            </Stack>
            {
              (listAdmin.length > 0)?
                <Button variant='contained' startIcon={<SendRounded/>} onClick={() => {
                    writeDataAdmin(listAdmin).then(resp => {setResponse(resp)}).catch(err  => {setError(err.message)})
                  }}>
                  Send To Server
                </Button>:null
            }
          </Stack>
        </Paper>
      </Stack>
      <Section name="Backup & Clean Data" align="left"/>
      <Stack width="100%" sx={{maxWidth:'500px'}} spacing={2}>
        <Button color='secondary' variant='contained' startIcon={<BackupRounded/>} onClick={() => {backup().catch(error => setError(error.message))}}>
          Backup
        </Button>
        {
          (oldImgs.length > 0)? 
            <>
              <Alert severity='warning'>
                <AlertTitle>You have {oldImgs.length} old imgs, backup and delete now</AlertTitle>
                Remember, you have {500 - oldImgs.length} space for stored old imgs, if limit reached you can`t add images again
              </Alert>
              <Button color='warning' variant='contained' startIcon={<RestoreFromTrashRounded/>} onClick={() => {cleanImgAndBackup(oldImgs).catch(error => setError(error.message))}}>
                Clean and Backup
              </Button>
            </>:null
        }
        <TextField
          required
          type='number'
          label='Remove Scale'
          variant='standard'
          value={removeScale}
          InputProps={{
            endAdornment: <InputAdornment position='end'>%</InputAdornment>
          }}
          onChange={(val) => {var value = val.currentTarget.value;if (Number(value) > 0 && Number(value) <= 100) setRemoveScale(value)}}
        />
        <Button color='error' variant='contained' startIcon={<DeleteForever/>} onClick={() => {setOpen(true)}}>
          Clean All Data
        </Button>
        <Dialog
          open={open}
          onClose={() => {setOpen(!open)}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Clean All Data
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure to clean all data ? <b/>make sure you have an all backup's from your data before clean it
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {setOpen(!open)}}>Cancel</Button>
            <Button onClick={() => {cleanOldData(dataAll,oldImgs,removeScale/100).then(dt => {dispatch(setData(dt));setResponse("Delete Complete !!!");setOpen(!open)}).catch(err => {setError(err.message)})}} autoFocus>
              Remove
            </Button>
          </DialogActions>
        </Dialog>
      </Stack>
    </Stack>
  )
}
